import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-content-between align-items-center mb-4",
  style: {"flex-wrap":"wrap","gap":"0.75rem"}
}
const _hoisted_2 = { class: "d-flex align-items-center gap-3" }
const _hoisted_3 = {
  class: "text-white mb-0 text-capitalize",
  style: {"font-weight":"800"}
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "border-style" }
const _hoisted_6 = {
  key: 0,
  class: "admin-alert admin-alert-success mb-4"
}
const _hoisted_7 = {
  key: 1,
  class: "admin-alert admin-alert-danger mb-4"
}
const _hoisted_8 = {
  key: 2,
  class: "text-silver"
}
const _hoisted_9 = {
  key: 3,
  class: "admin-card"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_ContentFieldEditor = _resolveComponent("ContentFieldEditor")!
  const _component_AdminLayout = _resolveComponent("AdminLayout")!

  return (_openBlock(), _createBlock(_component_AdminLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_RouterLink, {
            to: "/admin/content",
            class: "back-link"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "ti ti-arrow-left" }, null, -1),
              _createTextVNode(" All Sections ")
            ])),
            _: 1
          }),
          _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.sectionLabel), 1)
        ]),
        _createElementVNode("button", {
          class: "btn",
          disabled: _ctx.saving,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.saving ? "Saving..." : "Save Changes"), 1)
        ], 8, _hoisted_4)
      ]),
      (_ctx.saved)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Changes saved successfully."))
        : _createCommentVNode("", true),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.error), 1))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Loading..."))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_ContentFieldEditor, {
              modelValue: _ctx.content,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.content) = $event))
            }, null, 8, ["modelValue"])
          ]))
    ]),
    _: 1
  }))
}